import { render, staticRenderFns } from "./CollaboratorsInviteModal.vue?vue&type=template&id=757c7e40"
import script from "./CollaboratorsInviteModal.vue?vue&type=script&lang=ts"
export * from "./CollaboratorsInviteModal.vue?vue&type=script&lang=ts"
import style0 from "./CollaboratorsInviteModal.vue?vue&type=style&index=0&id=757c7e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports